<template>
    <div class="budget-planning" :class="{'loaded': data && !data.created_budget}">

        <!--historicRevenue = {{ (data.expenses.account_categories.filter(x => x.slug === 'omsaetning')[0].entries_total) }}
        <br><br>
        historicRevenuePerHour = {{ historicRevenuePerHour }}
        <br><br>
        totalHistoricHours = {{ totalHistoricHours }}
        <br><br>
        multiplyFactor = {{ multiplyFactor }}
        <br><br>
        additionalCoverage = {{ additionalCoverage }}-->

        <div class="floater" v-if="data && !data.created_budget">
            <div class="row" style="margin-bottom:0px;padding-bottom:0px;">
                <div class="goal-ebitda col-lg-3">
                    <div class="floater__inner">
                        <div class="lg">
                            <span v-if="stepsInitiated.ebitdagoal">
                                {{ data.ebitda.goal | currency }}
                            </span>
                            <span v-else>
                                -
                            </span>
                        </div>
                        <div>
                            Ønsket EBITDA (driftsoverskud)
                            <br>
                            <span v-if="stepsInitiated.coverageperhour">
                                <!--Beregnet EBITDA: <b>{{ calculatedEbitda | currency }}</b>-->
                                Beregnet EBITDA: <b>{{ resultList[resultList.length - 1].budget | currency }}</b>
                            </span>
                            <span v-else>
                                -
                            </span>
                        </div>
                    </div>
                </div>
                <div class="demand-for-zero-revenue col-lg-3">
                    <div class="floater__inner">
                        <div class="lg">
                            <span v-if="stepsInitiated.expenses && stepsInitiated.hours">
                                {{ demandForZeroRevenue | currency }}
                            </span>
                            <span v-else>
                                -
                            </span>
                        </div>
                        DB pr. time for at nå
                        <br>
                        nulpunktsomsætning
                    </div>
                </div>
                <div class="demand-for-goal col-lg-3">
                    <div class="floater__inner">
                        <div class="lg">
                            <span v-if="stepsInitiated.expenses && stepsInitiated.ebitdagoal && stepsInitiated.hours">
                                {{ demandForGoal | currency }}
                            </span>
                            <span v-else>
                                -
                            </span>
                        </div>
                        DB pr. time for at nå
                        <br>
                        ønsket EBITDA
                    </div>
                </div>
                <div class="calculated-coverage-per-hour col-lg-3">
                    <div class="floater__inner">
                        <!--<div v-if="stepsInitiated.coverageperhour" class="lg" :class="{'good': calculatedCoveragePerHour > demandForGoal, 'neutral': calculatedCoveragePerHour > demandForZeroRevenue, 'bad': calculatedCoveragePerHour < demandForZeroRevenue}">
                            {{ calculatedCoveragePerHour | currency }}
                        </div>-->
                        <div v-if="stepsInitiated.coverageperhour" class="lg" :class="{'good': displayedCoveragePerHour >= Math.ceil(demandForGoal), 'neutral': displayedCoveragePerHour > Math.ceil(demandForZeroRevenue), 'bad': displayedCoveragePerHour < Math.ceil(demandForZeroRevenue)}">
                            {{ displayedCoveragePerHour | currency }}
                        </div>
                        <div class="lg" v-else>
                            -
                        </div>
                        Beregnet DB pr. time
                        <br>
                        (ud fra dine indtastninger)
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showExpensesModal" class="expenses-modal">
            <div class="inner">
                <div class="inner__title">
                    Underkonti for "{{ showExpensesModal.name }}"
                </div>
                <div class="inner__list">
                    <table style="width:100%;">
                        <thead>
                            <tr>
                                <th align="left">Konto</th>
                                <th align="left">Navn</th>
                                <th align="right" v-show="!updatingBudget">Historisk</th>
                                <th align="right">
                                    <d-tooltip
                                        v-if="showExpensesModal.input_type === 'total'"
                                        identifier="budgetplanning.pencil.modal"
                                        placement="inline"
                                        @clicked="showExpensesModal.input_type = 'accounts'"
                                        icon="pencil"
                                    />
                                    Budget
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(account, index) in showExpensesModal.accounts.filter(x => x.entries_total !== 0)" :key="'account_' + index">
                                <td align="left">{{ account.account_number }}</td>
                                <td align="left">{{ account.name }}</td>
                                <td align="right" style="white-space:nowrap;" v-show="!updatingBudget">{{ account.entries_total | currency }}</td>
                                <td align="right" class="budget">
                                    <vue-autonumeric
                                        v-model="account.budget"
                                        :options="{
                                            digitGroupSeparator: '.',
                                            decimalCharacter: ',',
                                            decimalCharacterAlternative: '.',
                                            currencySymbol: '\u00a0kr.',
                                            currencySymbolPlacement: 's',
                                            roundingMethod: 'U',
                                            decimalPlaces: 0
                                        }"
                                        v-if="showExpensesModal.input_type === 'accounts'"
                                    ></vue-autonumeric>
                                    <span style="display:block;padding:4px;" v-else>
                                        {{ account.budget | currency }}
                                    </span>
                                </td>
                            </tr>
                            <tr style="font-weight:bold;">
                                <td align="left">Total</td>
                                <td></td>
                                <td align="right" v-show="!updatingBudget">{{ showExpensesModal.entries_total | currency }}</td>
                                <td align="right">{{ sum(showExpensesModal.accounts, 'budget') | currency }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="close-wrapper">
                    <button class="budget-btn" @click="closeExpensesModal(showExpensesModal.slug)">
                        Luk
                    </button>
                </div>
            </div>
        </div>

        <box-helper
            headline="Budgetlægning"
            identifier="budgetPlanning"
        />

        <div class="container section">

            <title-block headline="<b>Budgetlægning</b>" class="mb-xl" position="center">
                <p slot="text">
                    Læg dit budget
                </p>
            </title-block>

            <div style="font-weight:bold;padding:20px;background:#172b43;color:#fff;border-radius:4px;font-size:14px;" v-if="updatingBudget">
                OBS! Du er ved at opdatere dit eksisterende budget. Ønsker du at lægge et nyt budget, skal du gå til fanebladet Overblik og herefter vælge fanebladet Læg budget igen.
                <br>
                Hust at trykke Gem, når du er færdig med at ændre budgettet.
            </div>

            <div v-if="data && !data.created_budget">

                <!-- Data and budget periods -->
                <div class="row" style="margin-top:30px;">
                    <div class="col-lg-6">
                        <div v-if="updatingBudget">
                            Du er nu ved at ændre budgettet for perioden:
                        </div>
                        <div v-else>
                            Du er nu ved at lægge budget for perioden:<br>
                        </div>
                        <b>{{ data.periods.budget.from | moment('DD/MM/YYYY') }} - {{ data.periods.budget.to | moment('DD/MM/YYYY') }}</b>
                    </div>
                    <div class="col-lg-6" style="text-align:right;">
                        Du kigger på data fra perioden:<br>
                        <b>{{ data.periods.data.from | moment('DD/MM/YYYY') }} - {{ data.periods.data.to | moment('DD/MM/YYYY') }}</b>
                    </div>
                </div>

                <!-- Step switcher -->
                <div class="step-switcher" style="display:none;">
                    <div class="steps">
                        <div class="step" @click="step = 1" :class="{'active': step === 1}">
                            1. Omkostninger
                        </div>
                        <div class="step" @click="step = 2" :class="{'active': step === 2}">
                            2. Ønsket EBITDA (driftsoverskud)
                        </div>
                        <div class="step" @click="step = 3" :class="{'active': step === 3}">
                            3. Solgte timer
                        </div>
                        <div class="step" @click="step = 4" :class="{'active': step === 4}">
                            4. DB pr. time
                        </div>
                        <div class="step" @click="step = 5" :class="{'active': step === 5}">
                            5. Resultat
                        </div>
                    </div>
                </div>

                <!-- STEP: EXPENSES -->
                <div class="placeholder" style="margin-top:30px;" id="step-expenses">
                    <div class="placeholder__heading" :class="{'completed': stepsCompleted.expenses}">
                        <contentful-guide identifier="guide.expenses" type="icon" />
                        <i class="fas fa-check-circle" v-if="stepsCompleted.expenses"></i>
                        Omkostninger
                    </div>
                    <div class="placeholder padding">
                        <div v-if="!stepsInitiated.expenses" style="text-align:center;">
                            <contentful-guide identifier="guide.expenses" />
                            <button class="budget-btn" @click="stepsInitiated.expenses = true">
                                Kom i gang
                            </button>
                        </div>
                        <div v-if="stepsInitiated.expenses && stepsCompleted.expenses">
                            <div style="margin-bottom:15px;text-align:center">
                                Du har sat dine forventede omkostninger til <b>{{ totalExpenses | currency }}</b>
                            </div>
                            <vue-apex-charts
                                :height="300"
                                :options="expensesGraphOptions"
                                :series="totalExpensesPeriodisedSeries"
                                type="bar"
                            />
                            <div style="margin-top:15px;text-align:center;">
                                <button class="budget-btn" @click="stepsCompleted.expenses = false">
                                    Vis / ret indtastning
                                </button>
                            </div>
                        </div>
                        <div v-if="stepsInitiated.expenses && !stepsCompleted.expenses">
                            <table style="width:100%;">
                                <thead>
                                    <tr>
                                        <th align="left">Konto</th>
                                        <th align="right">
                                            <span v-if="updatingBudget">
                                                Nuv. budget
                                            </span>
                                            <span v-else>
                                                Historisk
                                            </span>
                                        </th>
                                        <th align="right">
                                            <span v-if="updatingBudget">
                                                Rettet budget
                                            </span>
                                            <span v-else>
                                                Budget
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!--<tr>
                                        <td align="left">
                                            Difference på lønninger til svende
                                            <div style="padding-left:10px;">
                                                <small>
                                                    Ifølge sagsstyringssystemet har du brugt <b><span v-if="data.differences.employees.ordersystem > 0">-</span>{{ data.differences.employees.ordersystem | currency }}</b> på lønninger til svende.
                                                    <br>
                                                    Ifølge dit regnskabssystem har du brugt <b>{{ data.differences.employees.economic | currency }}</b> på lønninger til svende.
                                                    <br>
                                                    Det giver en difference på <b><span v-if="data.differences.employees.diff > 0">+</span>{{ data.differences.employees.diff | currency }}</b>
                                                </small>
                                            </div>
                                        </td>
                                        <td align="right">{{ data.differences.employees.diff | currency }}</td>
                                        <td align="right" class="budget">
                                            <input type="number" v-model="data.differences.employees.budget" style="text-align:right;width:100px;padding:2px 4px;border:1px solid #ccc;border-radius:4px;" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="left">
                                            Difference på materialer
                                            <div style="padding-left:10px;">
                                                <small>
                                                    Ifølge sagsstyringssystemet har du brugt <b><span v-if="data.differences.materials.ordersystem > 0">-</span>{{ data.differences.materials.ordersystem | currency }}</b> på materialer til opgaver.
                                                    <br>
                                                    Ifølge dit regnskabssystem har du brugt <b>{{ data.differences.materials.economic | currency }}</b> på materialer til opgaver.
                                                    <br>
                                                    Det giver en difference på <b><span v-if="data.differences.materials.diff > 0">+</span>{{ data.differences.materials.diff | currency }}</b>
                                                </small>
                                            </div>
                                        </td>
                                        <td align="right">{{ data.differences.materials.diff | currency }}</td>
                                        <td align="right" class="budget">
                                            <input type="number" v-model="data.differences.materials.budget" style="text-align:right;width:100px;padding:2px 4px;border:1px solid #ccc;border-radius:4px;" />
                                        </td>
                                    </tr>-->
                                    <tr v-for="(accountCategory, index) in expensesAccountCategories" :key="'accountCategory_' + index">
                                        <td align="left">
                                            <i class="fas fa-list fa-fw expense-icon" @click="openExpensesModal(accountCategory)" v-if="accountCategory.accounts.length > 0"></i>
                                            <i class="fas fa-list fa-fw expense-icon" style="opacity:0;" v-else />
                                            {{ accountCategory.name }}
                                            <span v-if="accountCategory.slug === 'vareforbrug'">
                                                &nbsp;<d-tooltip identifier="budgetplanning.materials.diff" placement="inline" />&nbsp;
                                                <i class="fas fa-calculator" style="opacity:0.5;" v-if="$auth.user().roles[0].name === 'super-admin'" v-tooltip="{
                                                    content: `
                                                        Ifølge sagsstyringssystemet har du brugt <b>${data.differences.materials.ordersystem > 0 ? '-' : ''}${$options.filters.currency(data.differences.materials.ordersystem)}</b> på materialer til opgaver.
                                                        <br><br>
                                                        Ifølge dit regnskabssystem har du brugt <b>${$options.filters.currency(data.differences.materials.economic)}</b> på materialer til opgaver.
                                                        <br><br>
                                                        Det giver en difference på <b>${$options.filters.currency(data.differences.materials.diff)}</b>
                                                    `
                                                }"></i>
                                            </span>
                                            <span v-if="accountCategory.slug === 'lonninger-svende'">
                                                &nbsp;<d-tooltip identifier="budgetplanning.employees.diff" placement="inline" />&nbsp;
                                                <i class="fas fa-calculator" style="opacity:0.5;" v-if="$auth.user().roles[0].name === 'super-admin'" v-tooltip="{
                                                    content: `
                                                        Ifølge sagsstyringssystemet har du brugt <b>${data.differences.employees.ordersystem > 0 ? '-' : ''}${$options.filters.currency(data.differences.employees.ordersystem)}</b> på lønninger til svende.
                                                        <br><br>
                                                        Ifølge dit regnskabssystem har du brugt <b>${$options.filters.currency(data.differences.employees.economic)}</b> på lønninger til svende.
                                                        <br><br>
                                                        Det giver en difference på <b>${$options.filters.currency(data.differences.employees.diff)}</b>
                                                    `
                                                }"></i>
                                            </span>
                                            <span v-if="accountCategory.slug === 'underleverandorer'">
                                                &nbsp;<d-tooltip identifier="budgetplanning.subcontractors" placement="inline" />&nbsp;
                                            </span>
                                        </td>
                                        <td align="right">
                                            <span v-if="updatingBudget">
                                                {{ accountCategory.old_budget | currency }}
                                            </span>
                                            <span v-else>
                                                {{ accountCategory.entries_total | currency }}
                                            </span>
                                        </td>
                                        <td align="right" class="budget" :class="{'edited-lower': updatingBudget && accountCategory.old_budget > accountCategory.budget, 'edited-higher': updatingBudget && accountCategory.old_budget < accountCategory.budget}">
                                            <vue-autonumeric
                                                v-model="accountCategory.budget"
                                                :options="{
                                                    digitGroupSeparator: '.',
                                                    decimalCharacter: ',',
                                                    decimalCharacterAlternative: '.',
                                                    currencySymbol: '\u00a0kr.',
                                                    currencySymbolPlacement: 's',
                                                    roundingMethod: 'U',
                                                    decimalPlaces: 0
                                                }"
                                                v-if="accountCategory.input_type === 'total'"
                                            ></vue-autonumeric>
                                            <span style="display:block;padding:4px;" v-else>
                                                <d-tooltip
                                                    identifier="budgetplanning.pencil.expenses"
                                                    placement="inline"
                                                    @clicked="accountCategory.input_type = 'total'"
                                                    icon="pencil"
                                                />
                                                {{ accountCategory.budget | currency }}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr style="font-weight:bold;">
                                        <td align="left">Total</td>
                                        <td align="right"><span v-if="totalHistoricExpenses > 0">-</span>{{ totalHistoricExpenses | currency }}</td>
                                        <td align="right" class="budget" :class="{'edited-lower': updatingBudget && totalHistoricExpenses > (totalExpenses * -1), 'edited-higher': updatingBudget && totalHistoricExpenses < (totalExpenses * -1)}"><span v-if="totalExpenses > 0">-</span>{{ totalExpenses | currency }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style="margin-top:15px;text-align:center;">
                                Evt. kommentar til "omkostninger"
                                <div>
                                    <textarea v-model="commentExpenses" placeholder="Kommentér eksempelvis på hvilke ting du har ændret, så du kan huske det til næste budgetlægning" rows="4" style="border:1px solid #ccc;border-radius:4px;padding:10px;text-align:left;width:50%;margin-top:10px;" />
                                </div>
                            </div>
                            <div style="margin-top:15px;text-align:center;">
                                <button class="budget-btn" @click="finishStep('expenses', 'step-expenses')">
                                    Gem og fortsæt
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- STEP: GOAL EBITDA -->
                <div class="placeholder" style="margin-top:30px;" id="step-ebitdagoal">
                    <div class="placeholder__heading" :class="{'completed': stepsCompleted.ebitdagoal}">
                        <contentful-guide identifier="guide.goal" type="icon" />
                        <i class="fas fa-check-circle" v-if="stepsCompleted.ebitdagoal"></i>
                        Ønsket EBITDA (driftsoverskud)
                    </div>
                    <div class="placeholder padding" style="text-align:center;">
                        <div v-if="!stepsInitiated.ebitdagoal">
                            <div style="text-align:center;" v-if="stepsCompleted.expenses">
                                <contentful-guide identifier="guide.goal" />
                                <button class="budget-btn" @click="stepsInitiated.ebitdagoal = true">
                                    Kom i gang
                                </button>
                            </div>
                            <div style="text-align:center;opacity:0.5;font-style:italic;" v-else>
                                Udfyld dine forventede omkostninger for at åbne dette punkt
                            </div>
                        </div>
                        <div v-if="stepsInitiated.ebitdagoal && stepsCompleted.ebitdagoal">
                            <div>Du har sat dit ønskede EBITDA til</div>
                            <div style="margin-top:15px;font-size:24px;font-weight:bold;">{{ data.ebitda.goal | currency }}</div>
                            <div style="margin-top:15px;text-align:center;">
                                <button class="budget-btn" @click="stepsCompleted.ebitdagoal = false">
                                    Vis / ret indtastning
                                </button>
                            </div>
                        </div>
                        <div v-if="stepsInitiated.ebitdagoal && !stepsCompleted.ebitdagoal">
                            <div v-if="updatingBudget" style="margin-bottom:15px;">
                                <div style="margin-bottom:5px;">
                                    <b>Nuv. budget:</b>
                                </div>
                                {{ data.ebitda.old_goal | currency }}
                            </div>
                            <!--Tip: Sidste periodes EBITDA var <b>{{ data.ebitda.previous | currency }}</b>
                            <br><br>-->
                            <div v-if="updatingBudget" style="margin-bottom:5px;">
                                <b>Rettet budget:</b>
                            </div>
                            <div class="autonumeric-wrap" :class="{'edited-higher': updatingBudget && data.ebitda.goal > data.ebitda.old_goal, 'edited-lower': updatingBudget && data.ebitda.goal < data.ebitda.old_goal}">
                                <vue-autonumeric
                                    v-model="data.ebitda.goal"
                                    :options="{
                                        digitGroupSeparator: '.',
                                        decimalCharacter: ',',
                                        decimalCharacterAlternative: '.',
                                        currencySymbol: '\u00a0kr.',
                                        currencySymbolPlacement: 's',
                                        roundingMethod: 'U',
                                        decimalPlaces: 0
                                    }"
                                ></vue-autonumeric>
                            </div>
                            <div style="margin-top:15px;text-align:center;">
                                Evt. kommentar til "ønsket EBITDA"
                                <div>
                                    <textarea v-model="commentEbitda" placeholder="Kommentér eksempelvis på hvilke ting du har ændret, så du kan huske det til næste budgetlægning" rows="4" style="border:1px solid #ccc;border-radius:4px;padding:10px;text-align:left;width:50%;margin-top:10px;" />
                                </div>
                            </div>
                            <div style="margin-top:30px;text-align:center">
                                <button class="budget-btn" @click="finishStep('ebitdagoal', 'step-ebitdagoal')">
                                    Gem og fortsæt
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- STEP: HOURS -->
                <div class="placeholder" style="margin-top:30px;" id="step-hours">
                    <div class="placeholder__heading" :class="{'completed': stepsCompleted.hours}">
                        <contentful-guide identifier="guide.hours" type="icon" />
                        <i class="fas fa-check-circle" v-if="stepsCompleted.hours"></i>
                        Solgte timer
                    </div>
                    <div class="placeholder padding">
                        <div v-if="!stepsInitiated.hours" style="text-align:center;">
                            <div style="text-align:center;" v-if="stepsCompleted.ebitdagoal">
                                <contentful-guide identifier="guide.hours" />
                                <button class="budget-btn" @click="stepsInitiated.hours = true">
                                    Kom i gang
                                </button>
                            </div>
                            <div style="text-align:center;opacity:0.5;font-style:italic;" v-else>
                                Udfyld dit ønskede EBITDA for at åbne dette punkt
                            </div>
                        </div>
                        <div v-if="stepsInitiated.hours && stepsCompleted.hours" style="text-align:center;">
                            <div>Du har sat forventede antal solgte timer til</div>
                            <div style="margin-top:15px;font-size:24px;font-weight:bold;">{{ totalHours | number }}</div>
                            <vue-apex-charts
                                :height="300"
                                :options="hoursGraphOptions"
                                :series="totalHoursPeriodisedSeries"
                                type="bar"
                            />
                            <div style="margin-top:15px;text-align:center;">
                                <button class="budget-btn" @click="stepsCompleted.hours = false">
                                    Vis / ret indtastning
                                </button>
                            </div>
                        </div>
                        <div v-if="stepsInitiated.hours && !stepsCompleted.hours">
                            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:30px;">
                                <div>
                                    Gennemsnitlig tid hos kunderne i perioden: <b>{{ (sum(employeesInPeriod, 'hours') / sum(employeesInPeriod, 'available_hours')) * 100 | number }}%</b>
                                    <br>
                                    Beregnet gennemsnitlig tid hos kunderne ud fra din indtastning: <b>{{ percentageHoursWithCustomers | number }}%</b>
                                </div>
                                <button class="budget-btn" v-if="!updatingBudget && hoursCalcType === 'projectTypes'" @click="hoursCalcType = 'employees'">
                                    Tryk her for at budgettere solgte timer ud fra medarbejdere i stedet
                                </button>
                                <button class="budget-btn" v-if="!updatingBudget && hoursCalcType === 'employees'" @click="hoursCalcType = 'projectTypes'">
                                    Tryk her for at budgettere solgte timer ud fra opgavetyper i stedet
                                </button>
                            </div>
                            <table style="width:100%;" v-if="hoursCalcType === 'projectTypes'">
                                <thead>
                                    <tr>
                                        <th align="left">Opgavetype</th>
                                        <th align="right">Antal opgaver</th>
                                        <th align="right">Gns. antal timer pr. opgave</th>
                                        <th align="right">Solgte timer historisk</th>
                                        <th align="right">Budget solgte timer</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(projectType, index) in data.hours.project_types" :key="'projectTypeHour_' + index">
                                        <td align="left">{{ projectType.name }}</td>
                                        <td align="right">{{ projectType.projects_count | number }}</td>
                                        <td align="right">{{ projectType.hours > 0 ? (projectType.hours / projectType.projects_count) : 0 | number }}</td>
                                        <td align="right">{{ projectType.hours | number }}</td>
                                        <td align="right" class="budget">
                                            <vue-autonumeric
                                                v-model="projectType.budget"
                                                :options="{
                                                    digitGroupSeparator: '.',
                                                    decimalCharacter: ',',
                                                    decimalCharacterAlternative: '.',
                                                    roundingMethod: 'U',
                                                    decimalPlaces: 0
                                                }"
                                            ></vue-autonumeric>
                                        </td>
                                    </tr>
                                    <tr style="font-weight:bold;">
                                        <td align="left">Total</td>
                                        <td align="right"></td>
                                        <td align="right"></td>
                                        <td align="right">{{ sum(data.hours.project_types, 'hours') | number }}</td>
                                        <td align="right">{{ sum(data.hours.project_types, 'budget') | number }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table style="width:100%;" v-if="hoursCalcType === 'employees'">
                                <thead>
                                    <tr>
                                        <th align="left">Medarbejder</th>
                                        <th align="right">Timer til rådighed</th>
                                        <th align="right">
                                            <span v-if="updatingBudget">
                                                Kundetid (nuv. budget)
                                            </span>
                                            <span v-else>
                                                Kundetid historisk
                                            </span>
                                        </th>
                                        <th align="right">Budget kundetid</th>
                                        <th align="right">
                                            <span v-if="updatingBudget">
                                                Nuv. budget
                                            </span>
                                            <span v-else>
                                                Solgte timer historisk
                                            </span>
                                        </th>
                                        <th align="right">
                                            <span v-if="updatingBudget">
                                                Rettet budget
                                            </span>
                                            <span v-else>
                                                Budget solgte timer
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(employee, index) in data.hours.employees" :key="'employeeHour_' + index">
                                        <td align="left">{{ employee.name === 'Planlagt ansættelse af nye svende' ? 'Planlagt ansættelse eller afskedigelse af svende/lærlinge' : employee.name }}</td>
                                        <td align="right">{{ employee.available_hours | number }}</td>
                                        <td align="right">
                                            <span v-if="updatingBudget">
                                                {{ employee.old_hours_with_project_percent | number }}%    
                                            </span>
                                            <span v-else>
                                                {{ employee.hours_with_project_percent_historic | number }}%
                                            </span>
                                        </td>
                                        <td align="right" style="padding-left:30px;">
                                            <div v-if="employee.name === 'Planlagt ansættelse af nye svende'">
                                                -
                                            </div>
                                            <div class="slider" style="margin:0;display:flex;align-items:center;" v-else>
                                                <input
                                                    type="range"
                                                    :min="0"
                                                    :max="125"
                                                    v-model="employee.hours_with_project_percent"
                                                    @input="employee.budget = (employee.hours_with_project_percent / 100) * employee.available_hours"
                                                    v-if="employee.budget_type === 'percent'"
                                                />
                                                <div style="padding-left:5px;width:50px;flex-shrink:0;" v-if="employee.budget_type === 'percent'">
                                                    {{ employee.hours_with_project_percent | number }}%
                                                </div>
                                                <div v-if="employee.budget_type === 'input'" style="padding:11px 0;">
                                                    <i class="fas fa-pencil" @click="employee.budget_type = 'percent'" style="opacity:0.75;"></i>
                                                    {{ employee.hours_with_project_percent | number }}%
                                                </div>
                                            </div>
                                        </td>
                                        <td align="right">
                                            <span v-if="updatingBudget">
                                                {{ employee.old_budget | number }}
                                            </span>
                                            <span v-else>
                                                {{ employee.hours | number }}
                                            </span>
                                        </td>
                                        <td align="right" class="budget" :class="{'edited-higher': updatingBudget && employee.budget > employee.old_budget, 'edited-lower': updatingBudget && employee.budget < employee.old_budget}">
                                            <vue-autonumeric
                                                v-model="employee.budget"
                                                :options="{
                                                    digitGroupSeparator: '.',
                                                    decimalCharacter: ',',
                                                    decimalCharacterAlternative: '.',
                                                    roundingMethod: 'U',
                                                    decimalPlaces: 0
                                                }"
                                                v-if="employee.budget_type === 'input'"
                                            ></vue-autonumeric>
                                            <div v-if="employee.budget_type === 'percent'">
                                                <i class="fas fa-pencil" @click="employee.budget_type = 'input'" style="opacity:0.75;"></i>
                                                {{ employee.budget | number }}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr style="font-weight:bold;">
                                        <td align="left">Total</td>
                                        <td align="right"></td>
                                        <td align="right"></td>
                                        <td align="right"></td>
                                        <td align="right">
                                            <span v-if="updatingBudget">
                                                {{ sum(data.hours.employees, 'old_budget') | number }}
                                            </span>
                                            <span v-else>
                                                {{ sum(data.hours.employees, 'hours') | number }}
                                            </span>
                                        </td>
                                        <td align="right" :class="{'edited-higher': updatingBudget && sum(data.hours.employees, 'old_budget') < sum(data.hours.employees, 'budget'), 'edited-lower': updatingBudget && sum(data.hours.employees, 'old_budget') > sum(data.hours.employees, 'budget')}">
                                            {{ sum(data.hours.employees, 'budget') | number }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style="margin-top:15px;text-align:center;">
                                Evt. kommentar til "solgte timer"
                                <div>
                                    <textarea v-model="commentHours" placeholder="Kommentér eksempelvis på hvilke ting du har ændret, så du kan huske det til næste budgetlægning" rows="4" style="border:1px solid #ccc;border-radius:4px;padding:10px;text-align:left;width:50%;margin-top:10px;" />
                                </div>
                            </div>
                            <div style="margin-top:15px;text-align:center;">
                                <button class="budget-btn" @click="finishStep('hours', 'step-hours')">
                                    Gem og fortsæt
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- STEP: COVERAGE PER HOUR -->
                <div class="placeholder" style="margin-top:30px;" id="step-coverageperhour">
                    <div class="placeholder__heading" :class="{'completed': stepsCompleted.coverageperhour}">
                        <contentful-guide identifier="guide.coverageperhour" type="icon" />
                        <i class="fas fa-check-circle" v-if="stepsCompleted.coverageperhour"></i>
                        DB pr. time
                    </div>
                    <div class="placeholder padding">
                        <div v-if="!stepsInitiated.coverageperhour" style="text-align:center;">
                            <div style="text-align:center;" v-if="stepsCompleted.hours">
                                <contentful-guide identifier="guide.coverageperhour" />
                                <button class="budget-btn" @click="stepsInitiated.coverageperhour = true">
                                    Kom i gang
                                </button>
                            </div>
                            <div style="text-align:center;opacity:0.5;font-style:italic;" v-else>
                                Udfyld forventet antal solgte timer for at åbne dette punkt
                            </div>
                        </div>
                        <div v-if="stepsInitiated.coverageperhour && stepsCompleted.coverageperhour" style="text-align:center;">
                            <div>Dit beregnede DB pr. time er</div>
                            <div style="margin-top:15px;font-size:24px;font-weight:bold;" :class="{'good': displayedCoveragePerHour >= Math.ceil(demandForGoal), 'neutral': displayedCoveragePerHour > Math.ceil(demandForZeroRevenue), 'bad': displayedCoveragePerHour < Math.ceil(demandForZeroRevenue)}">
                                {{ displayedCoveragePerHour | currency }}
                            </div>
                            <div style="margin-top:15px;text-align:center;">
                                <button class="budget-btn" @click="stepsCompleted.coverageperhour = false">
                                    Vis / ret indtastning
                                </button>
                            </div>
                        </div>
                        <div v-if="stepsInitiated.coverageperhour && !stepsCompleted.coverageperhour">
                            <div style="margin-bottom:15px;">
                                Gennemsnitligt DB pr. time historisk: <b>{{ coveragePerHourHistoric | currency }}</b>
                            </div>
                            <table style="width:100%;">
                                <thead>
                                    <tr>
                                        <th align="left">Opgavetype</th>
                                        <th align="right">Antal opgaver</th>
                                        <th align="right">
                                            Antal timer
                                            <span style="display:block;font-size:10px;opacity:0.5;">afsluttede opgaver</span>
                                        </th>
                                        <th align="right">
                                            Antal timer
                                            <span style="display:block;font-size:10px;opacity:0.5;">inkl. igangv. opgaver</span>
                                        </th>
                                        <th align="right">Gns. antal timer pr. opgave</th>
                                        <th align="right">
                                            <span v-if="updatingBudget">
                                                Nuv. budget
                                            </span>
                                            <span v-else>
                                                DB pr. time historisk
                                            </span>
                                        </th>
                                        <!--<th align="right">Kostpris pr. time historisk</th>-->
                                        <th align="right">
                                            <span v-if="updatingBudget">
                                                Rettet budget
                                            </span>
                                            <span v-else>
                                                Budget
                                            </span>
                                        </th>
                                        <th align="right">Gns. ekstra pris pr. opgave</th>
                                        <!--<th align="right">DB +/-</th>-->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(projectType, index) in data.coverage_per_hour.project_types" :key="'cphProjectType_' + index">
                                        <td align="left">{{ projectType.name }}</td>
                                        <td align="right">{{ projectType.projects_count | number }}</td>
                                        <td align="right">{{ projectType.hours | number }}</td>
                                        <td align="right">{{ projectType.hours_with_ongoing | number }}</td>
                                        <td align="right">{{ projectType.hours > 0 ? (projectType.hours / projectType.projects_count) : 0 | number }}</td>
                                        <td align="right" style="font-weight:bold;" v-if="!updatingBudget">
                                            <span v-if="projectType.coverage_per_hour > demandForGoal" class="good" style="display:flex;align-items:center;justify-content:flex-end;">
                                                {{ projectType.coverage_per_hour | currency }}
                                            </span>
                                            <span v-else-if="projectType.coverage_per_hour > demandForZeroRevenue" class="neutral" style="display:flex;align-items:center;justify-content:flex-end;">
                                                {{ projectType.coverage_per_hour | currency }}
                                            </span>
                                            <span v-else class="bad" style="display:flex;align-items:center;justify-content:flex-end;">
                                                {{ projectType.coverage_per_hour | currency }}
                                            </span>
                                        </td>
                                        <td align="right" style="font-weight:bold;" v-else>
                                            <span v-if="projectType.old_budget_coverage_per_hour > demandForGoal" class="good" style="display:flex;align-items:center;justify-content:flex-end;">
                                                {{ projectType.old_budget_coverage_per_hour | currency }}
                                            </span>
                                            <span v-else-if="projectType.old_budget_coverage_per_hour > demandForZeroRevenue" class="neutral" style="display:flex;align-items:center;justify-content:flex-end;">
                                                {{ projectType.old_budget_coverage_per_hour | currency }}
                                            </span>
                                            <span v-else class="bad" style="display:flex;align-items:center;justify-content:flex-end;">
                                                {{ projectType.old_budget_coverage_per_hour | currency }}
                                            </span>
                                        </td>
                                        <!--<td align="right">{{ projectType.cost_per_hour | currency }}</td>-->
                                        <td align="right" class="budget">
                                            <div style="font-weight:bold;" :class="{'good': projectType.budget_coverage_per_hour > demandForGoal, 'neutral': projectType.budget_coverage_per_hour > demandForZeroRevenue, 'bad': projectType.budget_coverage_per_hour < demandForZeroRevenue}">
                                                <vue-autonumeric
                                                    v-model="projectType.budget_coverage_per_hour"
                                                    :options="{
                                                        digitGroupSeparator: '.',
                                                        decimalCharacter: ',',
                                                        decimalCharacterAlternative: '.',
                                                        currencySymbol: '\u00a0kr.',
                                                        currencySymbolPlacement: 's',
                                                        roundingMethod: 'U',
                                                        decimalPlaces: 0
                                                    }"
                                                ></vue-autonumeric>
                                            </div>
                                        </td>
                                        <td align="right">
                                            <span v-if="updatingBudget">
                                                <span v-if="((projectType.budget_coverage_per_hour - projectType.old_budget_coverage_per_hour) * (projectType.hours > 0 ? (projectType.hours / projectType.projects_count) : 0)) > 0">+</span>{{ (projectType.budget_coverage_per_hour - projectType.old_budget_coverage_per_hour) * (projectType.hours > 0 ? (projectType.hours / projectType.projects_count) : 0) | currency }}
                                            </span>
                                            <span v-else>
                                                <span v-if="((projectType.budget_coverage_per_hour - projectType.coverage_per_hour) * (projectType.hours > 0 ? (projectType.hours / projectType.projects_count) : 0)) > 0">+</span>{{ (projectType.budget_coverage_per_hour - projectType.coverage_per_hour) * (projectType.hours > 0 ? (projectType.hours / projectType.projects_count) : 0) | currency }}
                                            </span>
                                        </td>
                                        <!--<td align="right" class="budget">
                                            <span v-if="projectType.coverage_per_hour !== projectType.budget_coverage_per_hour">
                                                <span v-if="((projectType.budget_coverage_per_hour - projectType.coverage_per_hour) * projectType.hours) > 0">+</span>{{ (projectType.budget_coverage_per_hour - projectType.coverage_per_hour) * projectType.hours | currency }}
                                            </span>
                                            <span v-else>
                                                -
                                            </span>
                                        </td>-->
                                    </tr>
                                    <!--<tr style="font-weight:bold;">
                                        <td align="left">Total</td>
                                        <td align="right"></td>
                                        <td align="right"></td>
                                        <td align="right"></td>
                                        <td align="right"></td>
                                        <td align="right"></td>
                                        <td align="right"><span v-if="additionalCoverage > 0">+</span>{{ additionalCoverage | currency }}</td>
                                    </tr>-->
                                </tbody>
                            </table>
                            <div style="margin-top:15px;text-align:center;">
                                Evt. kommentar til "DB pr. time"
                                <div>
                                    <textarea v-model="commentCPH" placeholder="Kommentér eksempelvis på hvilke ting du har ændret, så du kan huske det til næste budgetlægning" rows="4" style="border:1px solid #ccc;border-radius:4px;padding:10px;text-align:left;width:50%;margin-top:10px;" />
                                </div>
                            </div>
                            <div style="margin-top:15px;text-align:center;">
                                <button class="budget-btn" @click="finishStep('coverageperhour', 'step-coverageperhour')">
                                    Gem og fortsæt
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- STEP: RESULT -->
                <div class="placeholder" style="margin-top:30px;" id="step-result">
                    <div class="placeholder__heading">
                        Resultat
                    </div>
                    <div class="placeholder padding">
                        <div v-if="!allStepsCompleted" style="opacity:0.5;font-style:italic;text-align:center;">
                            Udfyld omkostninger, ønsket EBITDA, solgte timer samt DB pr. time for at se det endelige resultat her
                        </div>
                        <div v-else>
                            <table style="width:100%;">
                                <thead>
                                    <tr>
                                        <th align="left">Konto</th>
                                        <th align="right" v-if="!updatingBudget">Historisk</th>
                                        <th align="right" v-if="updatingBudget">Nuv. budget</th>
                                        <th align="right">
                                            <span v-if="updatingBudget">Nyt budget</span>
                                            <span v-else>Budget</span>
                                        </th>
                                        <th align="right" style="font-style:italic;">
                                            Forskel
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(accountCategory, index) in resultList" :key="'resultAccountCategory_' + index">
                                        <td :class="{'bold': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)}" align="left">
                                            {{ accountCategory.name }}
                                        </td>
                                        <td v-if="!updatingBudget" :class="{'bold': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)}" align="right">
                                            {{ accountCategory.total | currency }}
                                        </td>
                                        <td v-if="updatingBudget" :class="{'bold': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)}" align="right">
                                            {{ accountCategory.oldBudget | currency }}
                                        </td>
                                        <td :class="{'bold': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)}" align="right" class="budget">
                                            {{ accountCategory.budget | currency }}
                                        </td>
                                        <td :class="{'bold': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)}" align="right" class="budget" style="font-style:italic;">
                                            <span v-if="updatingBudget">
                                                <span v-if="Math.round(accountCategory.budget) > Math.round(accountCategory.oldBudget)" class="good">
                                                    +{{ accountCategory.budget - accountCategory.oldBudget | currency }}
                                                </span>
                                                <span v-else-if="Math.round(accountCategory.budget) < Math.round(accountCategory.oldBudget)" class="bad">
                                                    {{ accountCategory.budget - accountCategory.oldBudget | currency }}
                                                </span>
                                                <span v-else>
                                                    -
                                                </span>
                                            </span>
                                            <span v-else>
                                                <span v-if="Math.round(accountCategory.budget) > Math.round(accountCategory.total)" class="good">
                                                    +{{ accountCategory.budget - accountCategory.total | currency }}
                                                </span>
                                                <span v-else-if="Math.round(accountCategory.budget) < Math.round(accountCategory.total)" class="bad">
                                                    {{ accountCategory.budget - accountCategory.total | currency }}
                                                </span>
                                                <span v-else>
                                                    -
                                                </span>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style="margin-top:15px;text-align:center;">
                                Evt. kommentar til dette budget
                                <div>
                                    <textarea v-model="comment" placeholder="Kommentér eksempelvis på hvilke ting du har ændret, så du kan huske det til næste budgetlægning" rows="4" style="border:1px solid #ccc;border-radius:4px;padding:10px;text-align:left;width:50%;margin-top:10px;" />
                                </div>
                            </div>
                            <div style="margin-top:15px;text-align:center;">
                                <button class="budget-btn" @click="saveBudget()">
                                    <i class="fas fa-save fa-fw"></i>
                                    Gem budget
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div v-else-if="data && data.created_budget" style="text-align:center;" class="placeholder padding">
                Der er lagt et budget for perioden:<br><b>{{ data.created_budget.from | moment('DD/MM/YYYY') }} - {{ data.created_budget.to | moment('DD/MM/YYYY') }}</b>
                <br><br>
                Budgettet blev lagt:<br><b>{{ data.created_budget.created_at | moment('DD/MM/YYYY [kl.] HH:mm') }}</b>
                <br><br>
                <div v-if="data.created_budget.comment">
                    <div>Din egen kommentar til budgettet:</div>
                    <pre style="display:block;border:1px solid #ccc;padding:15px;border-radius:4px;width:50%;margin:10px auto 0 auto;font-family:inherit;text-align:left;">{{ data.created_budget.comment }}</pre>
                    <br>
                </div>
                <button class="budget-btn" @click="data.created_budget = null">
                    Læg et nyt budget
                </button>
                <span v-if="data.created_budget.data">
                    &nbsp;&nbsp;
                    <a href="/budget-laegning?update=1" class="budget-btn" style="text-decoration:none;">
                        Ret eksisterende budget
                    </a>
                </span>
            </div>

            <div v-else>
                <box-loading />
            </div>

        </div>

    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

.fa-pencil {
    cursor: pointer;
    transition: 0.3s ease all;

    &:hover {
        color: #03a9f4;
    }
}
.placeholder__heading {

    &.completed {
        background: $color--good;
    }
}
.autonumeric-wrap {

    input {
        background: rgba(23,43,67,0.05);
        border-radius: 4px !important;
        padding: 4px !important;
        border-top: none !important;
        border-bottom: none !important;
        border: none !important;
        // border-radius: 0px !important;
        height: 100%;
        width: 200px !important;
        text-align: center;
        width: 100px;
        color: inherit !important;
        font-weight: inherit !important;
    }
}
.step-switcher {

    .steps {
        display: flex;
        background: #fff;
        border-radius: $borderradius--main * 2;
        border: 1px solid #ccc;
        margin-top: $margin--main;

        .step {
            flex: 0 0 20%;
            padding: ($padding--small / 2) $padding--small;
            text-align: center;
            cursor: pointer;

            &:hover {
                background: #eee;
            }

            &.active {
                background: #172b43;
                color: #fff;
                font-weight: bold;
            }
        }
    }
}
.budget-planning {
    position: relative;
    
    &.loaded {
        padding-top: 130px;
        // padding-bottom: 100px;
    }
}
.floater {
    text-align: center;
    padding: $padding--small;
    padding-top: $padding--small * 2;
    position: fixed;
    top: 80px;
    left: 250px;
    right: 0;
    background: $bg--light;
    // padding: 0 ($padding--main + $padding--small);
    // padding-bottom: 5px;
    height: 135px;
    z-index: 9;
    // border-bottom: 1px solid #172b43;
    // border-top: 1px solid #eee;
    border-left: 1px solid #fff;
    display: flex;
    align-items: center;
    // box-shadow: $boxshadow--main;

    .row {
        align-items: center;

        > div {
            margin-bottom: 0px !important;
        }
    }

    &__inner {
        background: $color--white;
        padding: $padding--small;
        border-radius: $borderradius--main;
        box-shadow: $boxshadow--main;
    }

    .goal-ebitda {
        // text-align: left;

        input {
            font-size: 20px;
            font-weight: bold;
            background: rgba(23,43,67,0.05);
            border-radius: 4px !important;
            padding: 4px !important;
            border-top: none !important;
            border-bottom: none !important;
            border: none !important;
            // border-radius: 0px !important;
            height: 100%;
            width: 200px !important;
            text-align: inherit !important;
        }
    }

    .lg {
        font-size: $fontsize--large;
        font-weight: bold;
    }
}
.budget-period-selector {
    display: flex;
    justify-content: center;

    > div {
        display: flex;
        border-radius: $borderradius--large;
        border: 1px solid #eee;
        overflow: hidden;
        box-shadow: $boxshadow--light;
        
        > a {
            display: block;
            text-decoration: none;
            color: inherit;
            padding: $padding--small / 2;
            background: #fff;
            width: 300px;
            text-align: center;
            cursor: default;

            &:not(.active) {
                cursor: pointer;
            }

            &:hover {
                background: #f5f5f5;
            }

            &.active {
                background: $color--good;
                color: #fff;
                font-weight: bold;
            }
        }
    }
}
.expenses-modal {
    z-index: 9999;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;

    .inner {
        background: #fff;
        border-radius: $borderradius--main;
        padding: $margin--main;
        width: 800px;
        max-width: 80%;
        max-height: 80%;
        overflow-y: auto;

        &__title {
            font-size: $fontsize--large;
            font-weight: bold;
            margin-bottom: $margin--main;
        }

        .close-wrapper {
            margin-top: $margin--main;
        }
    }
}
.expense-icon {
    opacity: 0.5;
    transition: 0.3s ease all;
    cursor: pointer;

    &:hover {
        opacity: 1;
    }
}
.circle {
    height: 5px;
    width: 5px;
    border-radius: 5px;
    margin-right: 5px;
}
.neutral {
    color: $color--avg;

    .circle { background: $color--avg; }
}
.good {
    color: $color--good;

    .circle { background: $color--good; }
}
.bad {
    color: $color--bad;

    .circle { background: $color--bad; }
}
.neutral-bg {
    background: $color--avg;
}
.good-bg {
    background: $color--good;
}
.bad-bg {
    background: $color--bad;
}
.single-account-line {
    display: block;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
    border-top: 1px solid #eee;
    font-size: 14px;
}
.budget-btn {
    background: #172b43;
    color: #fff;
    padding: 5px 10px;
    border-radius: 4px;
    font-weight: 600;
    transition: 0.3s ease all;

    &:hover {
        background: #03a9f4;
    }
}
.footer-btn-wrap {
    margin-top: $margin--main;
    text-align: center;

    button {
        margin-top: $margin--small;
    }
}
.done {
    background: $color--good !important;
}
.bold {
    font-weight: bold;
}
.ebitda-input {
    background: rgba(23,43,67,0.05);
    border-radius: 4px !important;
    padding: 4px !important;
    border-top: none !important;
    border-bottom: none !important;
    border: none !important;
    // border-radius: 0px !important;
    height: 100%;
    width: 200px !important;
}
table {

    th {
        padding: 4px 4px;

        &:first-of-type {
            padding-left: 0px;
        }
    }

    td {
        padding: 4px 4px;
        border-top: 1px solid #eee;

        &:first-of-type {
            padding-left: 0px;
        }

        &.budget {
            padding: 4px;
            // padding: 0px 0px;
            width: 220px;

            input {
                background: rgba(23,43,67,0.05);
                border-radius: 4px !important;
                padding: 4px !important;
                border-top: none !important;
                border-bottom: none !important;
                border: none !important;
                // border-radius: 0px !important;
                height: 100%;
                width: 200px !important;
                text-align: right;
                width: 100px;
                color: inherit !important;
                font-weight: inherit !important;
            }
        }
    }
}

.edited-lower {
    color: $color--bad !important;
    font-weight: bold;

    i, i * {
        color: $color--dark !important;
    }
}

.edited-higher {
    color: $color--good !important;
    font-weight: bold;

    i, i * {
        color: $color--dark !important;
    }
}
</style>

<script>
import * as budgetService from '@/services/budgetService'
import moment from 'moment'
const VueAutonumeric = require('vue-autonumeric')
import VueApexCharts from 'vue-apexcharts'

export default {
    data () {
        return {
            comment: null,
            commentExpenses: null,
            commentEbitda: null,
            commentHours: null,
            commentCPH: null,
            multiplyFactor: 1,
            step: 0,
            stepsInitiated: {
                expenses: false,
                ebitdagoal: false,
                hours: false,
                coverageperhour: false,
                result: false
            },
            stepsCompleted: {
                expenses: false,
                ebitdagoal: false,
                hours: false,
                coverageperhour: false,
                result: false
            },
            data: null,
            loading: true,
            hoursCalcType: 'employees',
            showExpensesModal: null,
            options: {
                labels: [
                    'Jan.', 'Feb.', 'Mar.', 'Apr.', 'Maj.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dec.'
                ],
                yaxis: {
                    labels: {
                        formatter: value => {
                            if (value > 0) {
                                return this.$options.filters.currency(value)
                            }
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    /* showForSingleSeries: false,
                    showForNullSeries: false,
                    showForZeroSeries: false, */
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: ['#172b43', '#03a9f4']
            },
            series: [
                // { name: 'Historisk', data: [ 3135512, 3564253, 1978675, 6542345, 6782498, 9834872, 3726837, 8318913, 5892478, 2354634, 6233235, 2512597 ] },
                { name: 'Budget', data: [ 3564253, 1978675, 6542345, 6782498, 9834872, 3726837, 8318913, 5892478, 2354634, 6233235, 2512597, 3135512 ] }
            ],
            hoursGraphOptions: {
                labels: [
                    'Jan.', 'Feb.', 'Mar.', 'Apr.', 'Maj.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dec.'
                ],
                yaxis: {
                    labels: {
                        formatter: value => {
                            if (value > 0) {
                                return this.$options.filters.number(value) + ' timer'
                            }
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    /* showForSingleSeries: false,
                    showForNullSeries: false,
                    showForZeroSeries: false, */
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: ['#172b43', '#03a9f4']
            },
            expensesGraphOptions: {
                labels: [
                    'Jan.', 'Feb.', 'Mar.', 'Apr.', 'Maj.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dec.'
                ],
                yaxis: {
                    labels: {
                        formatter: value => {
                            if (value > 0) {
                                return this.$options.filters.currency(value)
                            }
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    /* showForSingleSeries: false,
                    showForNullSeries: false,
                    showForZeroSeries: false, */
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: ['#172b43', '#03a9f4'],
                chart: {
                    toolbar: {
                        show: false
                    }
                }
            },
            oldResultList: null
        }
    },
    mounted () {
        if (window.location.href.includes('accountingYear')) {
            this.getData('accountingYear')
        } else {
            this.getData()
        }
    },
    methods: {
        getData (period) {
            this.data = null
            let params = {
                period: period
            }
            // Tell the API to lay the saved budget figures over freshly read
            // history. Editing used to replay budgets.data wholesale, so a
            // budget kept planning against the hours that were on file the day
            // it was made.
            if (this.updatingBudget) {
                params.update = 1
            }
            budgetService.data(params, (response) => {
                // console.log(response.data)
                if (params.period === 'accountingYear') {
                    response.data.created_budget = null
                }
                if (this.updatingBudget) {
                    // Held onto before the line below, because this.data and
                    // response.data are then the same object and created_budget
                    // is cleared out of it.
                    const savedBudget = response.data.created_budget
                    this.data = response.data
                    // The snapshot this used to be read from carried
                    // created_budget as null, and three v-if's on the page key
                    // off it to decide whether the planning view is shown, so
                    // it has to look the same here.
                    this.data.created_budget = null
                    this.data.expenses.account_categories.forEach((accountCategory) => {
                        accountCategory.old_budget = JSON.parse(JSON.stringify(accountCategory.budget))
                    })
                    this.data.ebitda.old_goal = JSON.parse(JSON.stringify(this.data.ebitda.goal))
                    this.data.hours.employees.forEach((employee) => {
                        employee.old_hours_with_project_percent = JSON.parse(JSON.stringify(employee.hours_with_project_percent))
                        employee.old_budget = JSON.parse(JSON.stringify(employee.budget))
                    })
                    this.data.coverage_per_hour.project_types.forEach((projectType) => {
                        projectType.old_budget_coverage_per_hour = JSON.parse(JSON.stringify(projectType.budget_coverage_per_hour))
                    })
                    // Set comments if any
                    this.comment = savedBudget.comment
                    this.commentExpenses = savedBudget.comment_expenses
                    this.commentEbitda = savedBudget.comment_ebitda
                    this.commentHours = savedBudget.comment_hours
                    this.commentCPH = savedBudget.comment_cph
                    let oldResultList = Object.assign({}, this.resultList)
                    this.oldResultList = oldResultList
                } else {
                    this.data = response.data
                }
                this.calculateMultiplyFactor()
            }, (err) => {
                console.log(err)
            })
        },
        sum (arr, key) {
            return arr.reduce((a, b) => a + (Number(b[key]) || 0), 0)
        },
        sumTwice (arr, key, secondKey) {
            return arr.reduce((a, b) => a + (Number(b[key][secondKey]) || 0), 0)
        },
        finishStep (step, divId) {
            this.stepsCompleted[step] = true
            const el = document.getElementById(divId)
            const pageElement = document.getElementsByClassName('page')[0]
            setTimeout(() => {
                pageElement.scroll({
                    behavior: 'smooth',
                    left: 0,
                    top: el.offsetTop - 25
                })
            }, 100)
        },
        saveBudget () {
            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at lægge et budget i demo-versionen.')
                return
            }
            if (this.data) {
                let body = {
                    // Dates
                    from: moment(this.data.periods.budget.from).format('YYYY-MM-DD'),
                    to: moment(this.data.periods.budget.to).format('YYYY-MM-DD'),
                    // Key figures
                    ebitda_goal: this.data.ebitda.goal,
                    ebitda_calculated: this.resultList[this.resultList.length - 1].budget,
                    total_expenses: this.totalExpenses,
                    total_hours: this.totalHours,
                    cph_zero_revenue: this.demandForZeroRevenue,
                    cph_goal_ebitda: this.demandForGoal,
                    cph_calculated: this.calculatedCoveragePerHour,
                    // Hours divided into months
                    hours_january: Object.values(this.totalHoursPeriodised)[0].hours,
                    hours_february: Object.values(this.totalHoursPeriodised)[1].hours,
                    hours_march: Object.values(this.totalHoursPeriodised)[2].hours,
                    hours_april: Object.values(this.totalHoursPeriodised)[3].hours,
                    hours_may: Object.values(this.totalHoursPeriodised)[4].hours,
                    hours_june: Object.values(this.totalHoursPeriodised)[5].hours,
                    hours_july: Object.values(this.totalHoursPeriodised)[6].hours,
                    hours_august: Object.values(this.totalHoursPeriodised)[7].hours,
                    hours_september: Object.values(this.totalHoursPeriodised)[8].hours,
                    hours_october: Object.values(this.totalHoursPeriodised)[9].hours,
                    hours_november: Object.values(this.totalHoursPeriodised)[10].hours,
                    hours_december: Object.values(this.totalHoursPeriodised)[11].hours,
                    project_types: this.data.coverage_per_hour.project_types,
                    expenses: this.totalExpensesPeriodised,
                    data: JSON.stringify(this.data),
                    comment: this.comment,
                    comment_expenses: this.commentExpenses,
                    comment_ebitda: this.commentExpenses,
                    comment_hours: this.commentHours,
                    comment_cph: this.commentCPH
                }
                budgetService.create(body, (response) => {
                    console.log(response.data)
                    alert('Budgettet er nu gemt. Siden opdateres...')
                    window.location.replace(location.pathname)
                }, (err) => {
                    console.log(err)
                })
            }
        },
        openExpensesModal (actc) {
            const accountCategory = this.data.expenses.account_categories.filter(x => x.slug === actc.slug)[0]
            let untouched = true
            accountCategory.accounts.forEach((account) => {
                if (account.entries_total !== account.budget) {
                    untouched = false
                }
            })
            if (untouched) {
                let multiplyFactor = accountCategory.budget / accountCategory.entries_total
                accountCategory.accounts.forEach((account) => {
                    account.budget = account.entries_total * multiplyFactor
                })
            }
            this.showExpensesModal = actc
        },
        closeExpensesModal (accountCategorySlug) {
            // const accountCategory = this.data.expenses.account_categories.filter(x => x.slug === accountCategorySlug)[0]
            // accountCategory.budget = this.sum(accountCategory.accounts, 'budget')
            this.showExpensesModal = null
        },
        calculateMultiplyFactor () {
            const expenses = Math.abs(this.sum(this.expensesAccountCategories, 'entries_total'))
            const hours = this.totalHistoricHours
            const coveragePerHour = this.coveragePerHourHistoric
            const ebitda = this.resultList[this.resultList.length - 1].total
            const expensesPlusEbitda = expenses + ebitda
            const hoursTimesCoveragePerHour = hours * coveragePerHour
            const multiplyFactor = expensesPlusEbitda / hoursTimesCoveragePerHour
            this.multiplyFactor = multiplyFactor
        }
    },
    computed: {
        updatingBudget () {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString)
            let update = urlParams.get('update')
            if (update && update === '1') {
                return true
            }
            return false
        },
        projectTypeHours () {
            if (!this.data) { return 0 }
            const employeeHours = this.sum(this.data.hours.employees, 'hours')
            const projectTypeHours = this.sum(this.data.hours.project_types, 'hours')
            const multiplyFactor = employeeHours / projectTypeHours
            this.data.hours.project_types.forEach((projectType) => {
                const newValue = Math.round(projectType.hours * multiplyFactor)
                projectType.hours = newValue
                projectType.budget = newValue
            })
            return this.data.hours.project_types
        },
        expensesAccountCategories () {
            if (this.data) {
                return this.data.expenses.account_categories.filter(x => !['omsaetning'].includes(x.slug))
            }
            return null
        },
        totalHistoricExpenses () {
            if (!this.data) { return 0 }
            if (this.updatingBudget) {
                return this.sum(this.expensesAccountCategories, 'old_budget')
            }
            return this.sum(this.expensesAccountCategories, 'entries_total')
        },
        totalExpenses () {
            if (!this.data) { return 0 }
            return Math.abs(this.sum(this.expensesAccountCategories, 'budget'))
        },
        totalHours () {
            if (!this.data) { return 0 }
            if (this.hoursCalcType === 'projectTypes') {
                return this.sum(this.data.hours.project_types, 'budget')
            }
            if (this.hoursCalcType === 'employees') {
                return this.sum(this.data.hours.employees, 'budget')
            }
        },
        totalHistoricHours () {
            if (!this.data) { return 0 }
            if (this.hoursCalcType === 'projectTypes') {
                return this.sum(this.data.hours.project_types, 'hours')
            }
            if (this.hoursCalcType === 'employees') {
                return this.sum(this.data.hours.employees, 'hours')
            }
        },
        demandForZeroRevenue () {
            if (!this.data) { return 0 }
            const historicCoveragePerHour = this.coveragePerHourHistoric
            const calculatedRevenue = this.totalHours * this.historicRevenuePerHour
            let expenses = this.totalExpenses
            if (expenses < Math.abs(this.totalHistoricExpenses)) {
                expenses = Math.abs(this.totalHistoricExpenses) - ((Math.abs(this.totalHistoricExpenses) - expenses) * 0.1)
            }
            const extraExpenses = this.additionalMaterialExpenses + this.additionalSubContractorsExpenses
            const expensesTotal = expenses - extraExpenses
            const diff = expensesTotal - calculatedRevenue
            const hours = this.totalHours
            const change = diff / hours
            const result = historicCoveragePerHour + change
            if (result < 0) {
                return 0
            }
            return result
        },
        demandForGoal () {
            if (!this.data) { return 0 }
            const historicCoveragePerHour = this.coveragePerHourHistoric
            const calculatedRevenue = this.totalHours * this.historicRevenuePerHour
            const extraExpenses = this.additionalMaterialExpenses + this.additionalSubContractorsExpenses
            let expenses = this.totalExpenses
            if (expenses < Math.abs(this.totalHistoricExpenses)) {
                expenses = Math.abs(this.totalHistoricExpenses) - ((Math.abs(this.totalHistoricExpenses) - expenses) * 0.1)
            }
            const expensesTotal = expenses - extraExpenses
            const goalEbitda = this.data.ebitda.goal
            const diff = (expensesTotal + goalEbitda) - calculatedRevenue
            const hours = this.totalHours
            const change = diff / hours
            const result = historicCoveragePerHour + change
            if (result < 0) {
                return 0
            }
            return result
        },
        // Both places that show the calculated coverage per hour read this, so
        // they cannot disagree: the header floored the value while the panel
        // below let the currency filter round it, and 567,6 was shown as 567
        // in one and 568 in the other. Flooring is the deliberate choice - it
        // pairs with Math.ceil on the demand figures, so a rounding never
        // colours a budget green that has not actually cleared the bar.
        displayedCoveragePerHour () {
            return Math.floor(this.calculatedCoveragePerHour)
        },
        calculatedCoveragePerHour () {
            if (!this.data) { return 0 }
            // const coverage = this.sum(this.data.coverage_per_hour.project_types, 'coverage')
            // const additionalCoverage = this.additionalCoverage
            const coverage = this.totalCoverageForCPH
            const hours = this.sum(this.data.coverage_per_hour.project_types, 'hours')
            return coverage / hours
        },
        additionalCoverage () {
            if (!this.data) { return 0 }
            const multiplyFactor = this.sum(this.data.coverage_per_hour.project_types, 'hours') / this.sum(this.data.hours.employees, 'hours')
            let total = 0
            this.data.coverage_per_hour.project_types.forEach((projectType) => {
                if (projectType.coverage_per_hour !== projectType.budget_coverage_per_hour) {
                    let diff = projectType.budget_coverage_per_hour - projectType.coverage_per_hour
                    total += diff * projectType.hours * multiplyFactor
                }
            })
            return total
        },
        totalCoverageForCPH () {
            if (!this.data) { return 0 }
            let total = 0
            this.data.coverage_per_hour.project_types.forEach((projectType) => {
                total += Number(projectType.hours) * Number(projectType.budget_coverage_per_hour)
            })
            return total
        },
        historicRevenuePerHour () {
            if (!this.data) { return 0 }
            const revenue = this.data.expenses.account_categories.filter(x => x.slug === 'omsaetning')[0].entries_total
            let hours = this.sum(this.data.hours.project_types, 'hours')
            if (this.hoursCalcType === 'employees') {
                hours = this.sum(this.data.hours.employees, 'hours')
            }
            return revenue / hours
        },
        historicMaterialExpensesPerHour () {
            if (!this.data) { return 0 }
            const materialExpenses = this.data.expenses.account_categories.filter(x => x.slug === 'vareforbrug')[0].entries_total
            let hours = this.sum(this.data.hours.project_types, 'hours')
            if (this.hoursCalcType === 'employees') {
                hours = this.sum(this.data.hours.employees, 'hours')
            }
            return materialExpenses / hours
        },
        additionalMaterialExpenses () {
            if (!this.data) { return 0 }
            const materialExpensesPerHour = this.historicMaterialExpensesPerHour
            const extraHours = this.totalHours - this.totalHistoricHours
            return materialExpensesPerHour * extraHours
        },
        historicSubContractorsPerHour () {
            if (!this.data) { return 0 }
            const subContractorsExpenses = this.data.expenses.account_categories.filter(x => x.slug === 'underleverandorer')[0].entries_total
            let hours = this.sum(this.data.hours.project_types, 'hours')
            if (this.hoursCalcType === 'employees') {
                hours = this.sum(this.data.hours.employees, 'hours')
            }
            return subContractorsExpenses / hours
        },
        additionalSubContractorsExpenses () {
            if (!this.data) { return 0 }
            const subContractorsPerHour = this.historicSubContractorsPerHour
            const extraHours = this.totalHours - this.totalHistoricHours
            return subContractorsPerHour * extraHours
        },
        calculatedRevenue () {
            if (!this.data) { return 0 }
            const budgetHours = this.totalHours
            const revenuePerHour = this.historicRevenuePerHour
            const coveragePerHour = this.calculatedCoveragePerHour
            const historicCoveragePerHour = this.coveragePerHourHistoric
            return budgetHours * revenuePerHour + ((coveragePerHour - historicCoveragePerHour) * budgetHours)
        },
        resultList () {
            if (!this.data) { return 0 }
            let arr = []
            arr.push({
                name: 'Omsætning',
                total: this.data.expenses.account_categories.filter(x => x.slug === 'omsaetning')[0].entries_total,
                budget: this.calculatedRevenue,
                oldBudget: this.oldResultList ? this.oldResultList[0].budget : 0
            })
            arr.push({
                name: 'Vareforbrug',
                total: this.data.expenses.account_categories.filter(x => x.slug === 'vareforbrug')[0].entries_total,
                budget: this.data.expenses.account_categories.filter(x => x.slug === 'vareforbrug')[0].budget + this.additionalMaterialExpenses,
                oldBudget: this.oldResultList ? this.oldResultList[1].budget : 0
            })
            arr.push({
                name: 'Underleverandører',
                total: this.data.expenses.account_categories.filter(x => x.slug === 'underleverandorer')[0].entries_total,
                budget: this.data.expenses.account_categories.filter(x => x.slug === 'underleverandorer')[0].budget + this.additionalSubContractorsExpenses,
                oldBudget: this.oldResultList ? this.oldResultList[2].budget : 0
            })
            // DB 1
            arr.push({
                name: 'Dækningsbidrag 1',
                total: this.sum(arr, 'total'),
                budget: this.sum(arr, 'budget'),
                oldBudget: this.oldResultList ? this.oldResultList[3].budget : 0
            })
            arr.push({
                name: 'Lønninger, svende',
                total: this.data.expenses.account_categories.filter(x => x.slug === 'lonninger-svende')[0].entries_total,
                budget: this.data.expenses.account_categories.filter(x => x.slug === 'lonninger-svende')[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[4].budget : 0
            })
            arr.push({
                name: 'Lønninger, administration',
                total: this.data.expenses.account_categories.filter(x => x.slug === 'lonninger-administration')[0].entries_total,
                budget: this.data.expenses.account_categories.filter(x => x.slug === 'lonninger-administration')[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[5].budget : 0
            })
            // DB 2
            arr.push({
                name: 'Dækningsbidrag 2',
                total: this.sum(arr.filter(x => !['Dækningsbidrag 1'].includes(x.name)), 'total'),
                budget: this.sum(arr.filter(x => !['Dækningsbidrag 1'].includes(x.name)), 'budget'),
                oldBudget: this.oldResultList ? this.oldResultList[6].budget : 0
            })
            arr.push({
                name: 'Arbejdstøj',
                total: this.data.expenses.account_categories.filter(x => x.slug === 'arbejdstoj')[0].entries_total,
                budget: this.data.expenses.account_categories.filter(x => x.slug === 'arbejdstoj')[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[7].budget : 0
            })
            arr.push({
                name: 'Biler, svende',
                total: this.data.expenses.account_categories.filter(x => x.slug === 'biler-svende')[0].entries_total,
                budget: this.data.expenses.account_categories.filter(x => x.slug === 'biler-svende')[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[8].budget : 0
            })
            arr.push({
                name: 'Biler, andre',
                total: this.data.expenses.account_categories.filter(x => x.slug === 'biler-andre')[0].entries_total,
                budget: this.data.expenses.account_categories.filter(x => x.slug === 'biler-andre')[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[9].budget : 0
            })
            arr.push({
                name: 'Telefoner, svende',
                total: this.data.expenses.account_categories.filter(x => x.slug === 'telefoner-svende')[0].entries_total,
                budget: this.data.expenses.account_categories.filter(x => x.slug === 'telefoner-svende')[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[10].budget : 0
            })
            arr.push({
                name: 'Telefoner, andre',
                total: this.data.expenses.account_categories.filter(x => x.slug === 'telefoner-andre')[0].entries_total,
                budget: this.data.expenses.account_categories.filter(x => x.slug === 'telefoner-andre')[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[11].budget : 0
            })
            arr.push({
                name: 'Husleje',
                total: this.data.expenses.account_categories.filter(x => x.slug === 'husleje')[0].entries_total,
                budget: this.data.expenses.account_categories.filter(x => x.slug === 'husleje')[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[12].budget : 0
            })
            arr.push({
                name: 'Rådgivning og konsulenter',
                total: this.data.expenses.account_categories.filter(x => x.slug === 'radgivning-og-konsulenter')[0].entries_total,
                budget: this.data.expenses.account_categories.filter(x => x.slug === 'radgivning-og-konsulenter')[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[13].budget : 0
            })
            arr.push({
                name: 'Abonnementer og kontingenter',
                total: this.data.expenses.account_categories.filter(x => x.slug === 'abonnementer-og-kontingenter')[0].entries_total,
                budget: this.data.expenses.account_categories.filter(x => x.slug === 'abonnementer-og-kontingenter')[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[14].budget : 0
            })
            arr.push({
                name: 'Forsikringer',
                total: this.data.expenses.account_categories.filter(x => x.slug === 'forsikringer')[0].entries_total,
                budget: this.data.expenses.account_categories.filter(x => x.slug === 'forsikringer')[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[15].budget : 0
            })
            arr.push({
                name: 'Markedsføring',
                total: this.data.expenses.account_categories.filter(x => x.slug === 'markedsforing')[0].entries_total,
                budget: this.data.expenses.account_categories.filter(x => x.slug === 'markedsforing')[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[16].budget : 0
            })
            arr.push({
                name: 'IT',
                total: this.data.expenses.account_categories.filter(x => x.slug === 'it')[0].entries_total,
                budget: this.data.expenses.account_categories.filter(x => x.slug === 'it')[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[17].budget : 0
            })
            arr.push({
                name: 'Øvrige omkostninger',
                total: this.data.expenses.account_categories.filter(x => x.slug === 'ovrige-omkostninger')[0].entries_total,
                budget: this.data.expenses.account_categories.filter(x => x.slug === 'ovrige-omkostninger')[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[18].budget : 0
            })
            arr.push({
                name: 'EBITDA',
                total: this.sum(arr.filter(x => !['Dækningsbidrag 1', 'Dækningsbidrag 2'].includes(x.name)), 'total'),
                budget: this.sum(arr.filter(x => !['Dækningsbidrag 1', 'Dækningsbidrag 2'].includes(x.name)), 'budget'),
                oldBudget: this.oldResultList ? this.oldResultList[19].budget : 0
            })
            return arr
        },
        allStepsCompleted () {
            if (!this.stepsCompleted.expenses) { return false }
            if (!this.stepsCompleted.ebitdagoal) { return false }
            if (!this.stepsCompleted.hours) { return false }
            if (!this.stepsCompleted.coverageperhour) { return false }
            return true
        },
        totalHoursPeriodised () {
            if (this.data) {
                // let arr = []
                let months = {
                    1: { name: 'Januar', hours: 0, historicalHours: 0 },
                    2: { name: 'Februar', hours: 0, historicalHours: 0 },
                    3: { name: 'Marts', hours: 0, historicalHours: 0 },
                    4: { name: 'April', hours: 0, historicalHours: 0 },
                    5: { name: 'Maj', hours: 0, historicalHours: 0 },
                    6: { name: 'Juni', hours: 0, historicalHours: 0 },
                    7: { name: 'Juli', hours: 0, historicalHours: 0 },
                    8: { name: 'August', hours: 0, historicalHours: 0 },
                    9: { name: 'September', hours: 0, historicalHours: 0 },
                    10: { name: 'Oktober', hours: 0, historicalHours: 0 },
                    11: { name: 'November', hours: 0, historicalHours: 0 },
                    12: { name: 'December', hours: 0, historicalHours: 0 }
                }
                this.data.hours.employees.forEach((employee) => {
                    let multiplyFactor = 1
                    if (employee.hours !== employee.budget) {
                        multiplyFactor = (employee.budget / (employee.hours > 0 ? employee.hours : 1))
                    }
                    for (let i = 1; i < 13; i++) {
                        months[i].hours += Number(employee.hours_division[i] > 0 ? employee.hours_division[i] : (1 / 12)) * multiplyFactor
                        months[i].historicalHours += Number(employee.hours_division[i])
                    }
                })
                if (this.sum(Object.values(months), 'hours') !== this.totalHours) {
                    const diff = this.totalHours - this.sum(Object.values(months), 'hours')
                    if (diff !== 0) {
                        for (let i = 1; i < 13; i++) {
                            months[i].hours = months[i].hours + (diff / 12)
                            /* if (Math.abs(months[i].hours) > Math.abs(diff)) {
                                months[i].hours = months[i].hours + diff
                                break
                            } */
                        }
                    }
                }
                return months
            }
            return []
        },
        totalHoursPeriodisedSeries () {
            let budgetArray = []
            let historicArray = []
            if (this.data) {
                let months = this.totalHoursPeriodised
                for (let i = 1; i < 13; i++) {
                    budgetArray.push(months[i].hours)
                    historicArray.push(months[i].historicalHours)
                }
                return [
                    // { name: 'Historisk', data: historicArray },
                    { name: 'Budget', data: budgetArray }
                ]
            }
            return [
                // { name: 'Historisk', data: historicArray },
                { name: 'Budget', data: budgetArray }
            ]
        },
        totalExpensesPeriodised () {
            if (this.data) {
                this.data.expenses.account_categories.forEach((accountCategory) => {
                    accountCategory.accounts.forEach((account) => {
                        let multiplyFactor = 1
                        // Revenue multiply factor
                        let revenueMultiplyFactor = 1
                        let historicRevenue = (this.data.expenses.account_categories.filter(x => x.slug === 'omsaetning')[0].entries_total)
                        revenueMultiplyFactor = this.calculatedRevenue / historicRevenue
                        // Material multiply factor
                        let materialMultiplyFactor = 1
                        let additionalMaterialExpenses = this.additionalMaterialExpenses
                        materialMultiplyFactor = (accountCategory.budget + additionalMaterialExpenses) / accountCategory.budget
                        // Subcontractors multiply factor
                        let subcontractorsMultiplyFactor = 1
                        let additionalSubContractorsExpenses = this.additionalSubContractorsExpenses
                        subcontractorsMultiplyFactor = (accountCategory.budget + additionalSubContractorsExpenses) / accountCategory.budget
                        let months = {
                            1: { name: 'Januar', expenses: 0, historicalExpenses: 0 },
                            2: { name: 'Februar', expenses: 0, historicalExpenses: 0 },
                            3: { name: 'Marts', expenses: 0, historicalExpenses: 0 },
                            4: { name: 'April', expenses: 0, historicalExpenses: 0 },
                            5: { name: 'Maj', expenses: 0, historicalExpenses: 0 },
                            6: { name: 'Juni', expenses: 0, historicalExpenses: 0 },
                            7: { name: 'Juli', expenses: 0, historicalExpenses: 0 },
                            8: { name: 'August', expenses: 0, historicalExpenses: 0 },
                            9: { name: 'September', expenses: 0, historicalExpenses: 0 },
                            10: { name: 'Oktober', expenses: 0, historicalExpenses: 0 },
                            11: { name: 'November', expenses: 0, historicalExpenses: 0 },
                            12: { name: 'December', expenses: 0, historicalExpenses: 0 },
                            13: { name: 'Total', expenses: 0, historicalExpenses: 0 }
                        }
                        if (account.entries_total !== account.budget) {
                            multiplyFactor = (account.budget / (account.entries_total !== 0 ? account.entries_total : 1))
                        }
                        for (let i = 1; i < 13; i++) {
                            months[i].expenses += Number(account.entries_division[i] !== 0 ? account.entries_division[i] * multiplyFactor : 0)
                            months[i].historicalExpenses += Number(account.entries_division[i])
                            // For additional (revenue, materials, subcontractors)
                            if (accountCategory.slug === 'omsaetning') {
                                if (months[i].expenses !== 0) {
                                    months[i].expenses = months[i].expenses * revenueMultiplyFactor
                                }
                            }
                            if (accountCategory.slug === 'vareforbrug') {
                                if (months[i].expenses !== 0) {
                                    months[i].expenses = months[i].expenses * materialMultiplyFactor
                                }
                            }
                            if (accountCategory.slug === 'underleverandorer') {
                                if (months[i].expenses !== 0) {
                                    months[i].expenses = months[i].expenses * subcontractorsMultiplyFactor
                                }
                            }
                            // Round
                            months[i].expenses = Math.round(months[i].expenses)
                        }
                        // Fix potential differences
                        if (accountCategory.slug === 'omsaetning') {
                            if ((account.budget * revenueMultiplyFactor) !== this.sum(Object.values(months), 'expenses')) {
                                const revenueDiff = (account.budget * revenueMultiplyFactor) - this.sum(Object.values(months), 'expenses')
                                if (revenueDiff !== 0) {
                                    for (let i = 1; i < 13; i++) {
                                        if (Math.abs(months[i].expenses) > Math.abs(revenueDiff)) {
                                            months[i].expenses = months[i].expenses + revenueDiff
                                            break
                                        }
                                    }
                                }
                            }
                        } else if (accountCategory.slug === 'vareforbrug') {
                            if ((account.budget * materialMultiplyFactor) !== this.sum(Object.values(months), 'expenses')) {
                                const revenueDiff = (account.budget * materialMultiplyFactor) - this.sum(Object.values(months), 'expenses')
                                if (revenueDiff !== 0) {
                                    for (let i = 1; i < 13; i++) {
                                        if (Math.abs(months[i].expenses) > Math.abs(revenueDiff)) {
                                            months[i].expenses = months[i].expenses + revenueDiff
                                            break
                                        }
                                    }
                                }
                            }
                        } else if (accountCategory.slug === 'underleverandorer') {
                            if ((account.budget * subcontractorsMultiplyFactor) !== this.sum(Object.values(months), 'expenses')) {
                                const revenueDiff = (account.budget * subcontractorsMultiplyFactor) - this.sum(Object.values(months), 'expenses')
                                if (revenueDiff !== 0) {
                                    for (let i = 1; i < 13; i++) {
                                        if (Math.abs(months[i].expenses) > Math.abs(revenueDiff)) {
                                            months[i].expenses = months[i].expenses + revenueDiff
                                            break
                                        }
                                    }
                                }
                            }
                        } else {
                            if (account.budget !== this.sum(Object.values(months), 'expenses')) {
                                const diff = Math.round(account.budget) - this.sum(Object.values(months), 'expenses')
                                if (diff !== 0) {
                                    for (let i = 1; i < 13; i++) {
                                        if (Math.abs(months[i].expenses) > Math.abs(diff)) {
                                            months[i].expenses = months[i].expenses + diff
                                            break
                                        }
                                    }
                                }
                            }
                        }
                        account.months = months
                        account.monthsTotal = this.sum(Object.values(months), 'expenses')
                        return account
                    })
                })
                return this.data.expenses.account_categories
            }
            return []
        },
        totalExpensesPeriodisedSeries () {
            let budgetArray = []
            let historicArray = []
            if (this.data) {
                let months = {
                    1: { name: 'Januar', expenses: 0, historicalExpenses: 0 },
                    2: { name: 'Februar', expenses: 0, historicalExpenses: 0 },
                    3: { name: 'Marts', expenses: 0, historicalExpenses: 0 },
                    4: { name: 'April', expenses: 0, historicalExpenses: 0 },
                    5: { name: 'Maj', expenses: 0, historicalExpenses: 0 },
                    6: { name: 'Juni', expenses: 0, historicalExpenses: 0 },
                    7: { name: 'Juli', expenses: 0, historicalExpenses: 0 },
                    8: { name: 'August', expenses: 0, historicalExpenses: 0 },
                    9: { name: 'September', expenses: 0, historicalExpenses: 0 },
                    10: { name: 'Oktober', expenses: 0, historicalExpenses: 0 },
                    11: { name: 'November', expenses: 0, historicalExpenses: 0 },
                    12: { name: 'December', expenses: 0, historicalExpenses: 0 }
                }
                this.totalExpensesPeriodised.filter(x => x.slug !== 'omsaetning').forEach((accountCategory) => {
                    accountCategory.accounts.forEach((account) => {
                        for (let i = 1; i < 13; i++) {
                            months[i].expenses += account.months[i].expenses * -1
                            months[i].historicalExpenses += account.months[i].historicalExpenses * -1
                        }
                    })
                })
                for (let i = 1; i < 13; i++) {
                    budgetArray.push(months[i].expenses)
                    historicArray.push(months[i].historicalExpenses)
                }
                return [
                    // { name: 'Historisk', data: historicArray },
                    { name: 'Budget', data: budgetArray }
                ]
            }
            return [
                // { name: 'Historisk', data: historicArray },
                { name: 'Budget', data: budgetArray }
            ]
        },
        // Employees who were actually in play during the period. An employee
        // with neither hours behind them nor hours budgeted ahead of them adds
        // a full year of available hours to the denominator and nothing to the
        // numerator: Brdr. Jensen carries 29 rows literally named "Slettet",
        // which dragged the customer time percentage from 67 down to 29. They
        // are only left out of these percentages, not out of the list, so an
        // employee who has yet to register anything can still be budgeted.
        employeesInPeriod () {
            if (!this.data) { return [] }
            return this.data.hours.employees.filter(x => Number(x.hours) > 0 || Number(x.budget) > 0)
        },
        percentageHoursWithCustomers () {
            if (!this.data) { return null }
            const employees = this.employeesInPeriod.filter(x => x.name !== 'Planlagt ansættelse af nye svende')
            let availableHours = this.sum(employees, 'available_hours')
            let budgetHours = this.sum(employees, 'budget')
            return (budgetHours / availableHours) * 100
        },
        coveragePerHourHistoric () {
            if (!this.data) { return null }
            const hours = this.sum(this.data.coverage_per_hour.project_types, 'hours')
            let total = 0
            this.data.coverage_per_hour.project_types.forEach((projectType) => {
                total += Number(projectType.hours) * Number(projectType.coverage_per_hour)
            })
            return total / hours
            // return this.sum(this.data.coverage_per_hour.project_types, 'coverage') / this.sum(this.data.coverage_per_hour.project_types, 'hours')
        },
        testEbitda () {
            if (!this.data) { return null }
            let total = 0
            this.totalExpensesPeriodised.forEach((accountCategory) => {
                accountCategory.accounts.forEach((account) => {
                    total += account.monthsTotal
                })
            })
            return total
        },
        employeeHours () {
            if (!this.data) { return null }
            return this.sum(this.data.hours.employees, 'budget')
        }
    },
    components: {
        VueAutonumeric,
        VueApexCharts,
        'contentful-guide': require('../../components/elements/ContentfulGuide')
    },
    watch: {
        expensesAccountCategories: {
            deep: true,
            handler (newValue, oldValue) {
                if (newValue !== null && newValue.length > 0) {
                    newValue.forEach((accountCategory) => {
                        if (accountCategory.input_type === 'accounts') {
                            let total = 0
                            accountCategory.accounts.forEach((account) => {
                                total += account.budget
                            })
                            accountCategory.budget = total
                        }
                        if (accountCategory.input_type === 'total') {
                            if (accountCategory.budget !== accountCategory.entries_total && accountCategory.entries_total !== 0) {
                                let multiplyFactor = 1
                                multiplyFactor = accountCategory.budget / accountCategory.entries_total
                                accountCategory.accounts.forEach((account) => {
                                    account.budget = account.entries_total * multiplyFactor
                                })
                            }
                        }
                    })
                }
            }
        },
        employeeHours: {
            handler () {
                this.data.hours.employees.forEach((employee) => {
                    if (employee.budget_type === 'input') {
                        employee.hours_with_project_percent = (employee.budget / employee.available_hours) * 100
                    }
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// index.vue?5cda6d1a